import { RootState } from "../store";

export const schoolSelector = (state: RootState) => state.school;
